import 'Layouts/default'
import 'Common/anchor'
import './catalog/catalog'

import { rStickySidebar } from 'Components/sticky-sidebar'
import { scrollTo } from 'Common/anchor'

for (const fakeBrandFilterEl of document.querySelectorAll('.js-fake-brand-filter')) {
    fakeBrandFilterEl.addEventListener('click', (event) => {
        const href = event.currentTarget.getAttribute('href')

        if (href) {
            window.location.href = href
            return
        }

        const filterSelectEl = document.querySelector('select[name="filter[brands][]"]')

        if (!filterSelectEl) {
            event.currentTarget.style.display = 'none'
            return
        }

        event.preventDefault()
        filterSelectEl.value = event.currentTarget.dataset.brandId
        $(filterSelectEl).multiselect('refresh')

        FilterBubbles.refresh($(filterSelectEl))
        Filter.submit()

        scrollTo(document.querySelector('.l-catalog-products') || document.querySelector('.listing'), 0)
    })
}

for (const triggerEl of document.querySelectorAll('.js-filter-brand-content-trigger')) {
    triggerEl.addEventListener('click', (event) => {
        event.preventDefault()

        const fakeBrandFilterEl = document.querySelector(`.js-fake-brand-filter[data-brand-id="${event.currentTarget.dataset.filterBrandId}"]`)

        if (fakeBrandFilterEl) {
            fakeBrandFilterEl.click()
        }
    })
}

for (const triggerEl of document.querySelectorAll('.js-filter-brand-content-trigger')) {
    const brandId = triggerEl.dataset.filterBrandId
    const fakeBrandFilterEl = document.querySelector(`.js-fake-brand-filter[data-brand-id="${brandId}"]`)

    if (!fakeBrandFilterEl) {
        triggerEl.style.display = 'none'
    }
}

const stickySidebar = new rStickySidebar({
    holderSelector: '.js-filter-sidebar-holder',
    options: {
        containerSelector: '.js-filter-sidebar-container',
        innerWrapperSelector: '.js-filter-sidebar-inner-wrapper',
        stickyClass: 'is-affixed',
        minWidth: 1199
    }
});

stickySidebar.init();

const headerEl = document.querySelector('.js-page-header')
if (headerEl) {
    headerEl.addEventListener('stick-change', (event) => {
        if (!event.detail.isStuck) return

        setTimeout(() => stickySidebar.updateSticky(), 250)
    });
}

window.stickySidebar = stickySidebar